import { useEffect, useState } from "react";
import { showApiErrorMessages } from "../../../../helpers";
import { fetchInsightsDashboard } from "../../../../api/endpoints/supervisors/tutors";
import { useParams } from "react-router-dom";
import { FullSpinner } from "../../../../components/LoadingSpinner";

export default function InsightsDashboard() {
  const [metabaseUrl, setMetabaseUrl] = useState<string>("");
  const { id } = useParams();

  useEffect(()=>{
    fetchMetabaseURL();
  }, [id]);

  const fetchMetabaseURL = async () =>{
    const response = await fetchInsightsDashboard(id!);
    if (response?.isSuccess){
        const { data: {metabase_url} } = response;
        setMetabaseUrl(metabase_url);
    } else { 
        showApiErrorMessages(response!);
    }
  };

  if (!metabaseUrl) {
      return <FullSpinner size={132} />
  }
  return (
    <div className="w-full h-full bg-gray-50 flex flex-col justify-between ">
      <div className="flex flex-col h-full min-w-full w-fit">
      <iframe 
        title="metabase"
        src={metabaseUrl} 
        frameBorder={0}
        width={'100%'}
        height={'100%'}
        allowTransparency
      />
      </div>
    </div>
  );
}
